/* RareLife landing sections: "GET x% OFF" buttons scroll smoothly to the buy box. */
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-rl-scroll-to-buy]');
  if (!link) return;
  var target = document.getElementById('rl-buy');
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
